import { render, staticRenderFns } from "./InsurersPage.vue?vue&type=template&id=836e7f7c&"
import script from "./InsurersPage.vue?vue&type=script&lang=js&"
export * from "./InsurersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports